export type PricingPlanModel = {
  id: number,
  cache_key: number,
  data?: any,
  is_free: boolean,
  is_prepaid: boolean,
  title: string,
}

const state = {
  data: {},
  id: null,
  is_free: false,
  is_prepaid: false,
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
